import { c as _c } from "react/compiler-runtime";
import { Form } from '@onefootprint/ui';
import capitalize from 'lodash/capitalize';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { GrantEditRightsFormData } from '../../types';
import useTenantScopeOptions from './hooks/use-tenant-scope-options';
const GrantEditRightsForm = () => {
  const $ = _c(57);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "components.privateLayout.assumeBanner.grantEditRightsDialog"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  const scopeOptions = useTenantScopeOptions();
  const {
    watch,
    setValue
  } = useFormContext();
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] !== scopeOptions.options || $[2] !== t || $[3] !== watch) {
    const isAdminSelected = watch("scopes").includes("admin");
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        "decrypt permissions": "Decrypt",
        "basic permissions": "",
        "compliance permissions": "",
        "proxy permissions": ""
      };
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    const permissionPrefixes = t6;
    const getFormattedOptions = () => scopeOptions.options.flatMap(optionGroup => {
      const prefix = permissionPrefixes[optionGroup.label.toLowerCase()] || "";
      return optionGroup.options.map(option => {
        const label = prefix ? `${prefix} ${option.label.toLowerCase()}` : capitalize(option.label);
        return {
          label: option.value === "admin" ? t(_temp) : label,
          value: option.value,
          disabled: isAdminSelected && option.value !== "admin"
        };
      });
    });
    t5 = "flex flex-col gap-5";
    T0 = Form.MultiSelect;
    t1 = "scopes";
    if ($[11] !== t) {
      t2 = t(_temp2);
      $[11] = t;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    if ($[13] !== t) {
      t3 = t(_temp3);
      $[13] = t;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    t4 = getFormattedOptions();
    $[1] = scopeOptions.options;
    $[2] = t;
    $[3] = watch;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    T0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[15] !== t) {
    t6 = t(_temp4);
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== setValue) {
    t7 = scopes => {
      if (scopes.includes("admin")) {
        setValue("scopes", ["admin"]);
      }
    };
    $[17] = setValue;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== T0 || $[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t6 || $[25] !== t7) {
    t8 = <T0 name={t1} label={t2} placeholder={t3} options={t4} hint={t6} hideSelectAll={true} onChange={t7} />;
    $[19] = T0;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t) {
    t9 = t(_temp5);
    $[27] = t;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t) {
    t10 = t(_temp6);
    $[29] = t;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t) {
    t11 = t(_temp7);
    $[31] = t;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t) {
    t12 = t(_temp8);
    $[33] = t;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12) {
    t13 = {
      max: {
        value: 30,
        message: t12
      }
    };
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t13 || $[40] !== t9) {
    t14 = <Form.Input size="compact" type="number" name="duration" label={t9} placeholder={t10} hint={t11} rules={t13} />;
    $[37] = t10;
    $[38] = t11;
    $[39] = t13;
    $[40] = t9;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== t) {
    t15 = t(_temp9);
    $[42] = t;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t) {
    t16 = t(_temp10);
    $[44] = t;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t) {
    t17 = t(_temp11);
    $[46] = t;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== t15 || $[49] !== t16 || $[50] !== t17) {
    t18 = <Form.Textarea name="reason" label={t15} placeholder={t16} hint={t17} />;
    $[48] = t15;
    $[49] = t16;
    $[50] = t17;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  let t19;
  if ($[52] !== t14 || $[53] !== t18 || $[54] !== t5 || $[55] !== t8) {
    t19 = <div className={t5}>{t8}{t14}{t18}</div>;
    $[52] = t14;
    $[53] = t18;
    $[54] = t5;
    $[55] = t8;
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  return t19;
};
export default GrantEditRightsForm;
function _temp($) {
  return $.scopes.admin;
}
function _temp2($_0) {
  return $_0.scopes.label;
}
function _temp3($_1) {
  return $_1.scopes.placeholder;
}
function _temp4($_2) {
  return $_2.scopes.hint;
}
function _temp5($_3) {
  return $_3.duration.label;
}
function _temp6($_4) {
  return $_4.duration.placeholder;
}
function _temp7($_5) {
  return $_5.duration.hint;
}
function _temp8($_6) {
  return $_6.duration.max;
}
function _temp9($_7) {
  return $_7.reason.label;
}
function _temp10($_8) {
  return $_8.reason.placeholder;
}
function _temp11($_9) {
  return $_9.reason.hint;
}